'use client';

import React from 'react';
import ContentSlider from 'components/commercetools-ui/organisms/content-slider';
import { ContentSliderProps } from 'components/commercetools-ui/organisms/content-slider/types';
import { TasticProps } from '../types';

const ContentSliderTasticSecond = ({ data }: TasticProps<ContentSliderProps>) => {
  return <ContentSlider data={data?.data?.dataSource} />;
};

export default ContentSliderTasticSecond;